class BenefitGroupLocationUpdatedInfoPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.benefit_group_name = systemNotificationPayloadData.benefit_group_name || '';
  }
}

export default BenefitGroupLocationUpdatedInfoPayload;
